import {
  activityResponseSchema,
  activitySummarySchema,
  type ActivityQuery,
  type ActivityResponse,
  type ActivitySummary,
  type ActivitySummaryQuery,
} from "@contract/firm/activity";
import { apiRequest } from "./client";

/** GET /v1/firm/activity (`view_activity`): one page of runs or actions; every filter runs
 * on the server (firm-model spec §9). */
export function fetchActivity(query: ActivityQuery): Promise<ActivityResponse> {
  const params = new URLSearchParams({ kind: query.kind, page: String(query.page) });
  if (query.from) params.set("from", query.from);
  if (query.to) params.set("to", query.to);
  if (query.member) params.set("member", query.member);
  if (query.skill) params.set("skill", query.skill);
  return apiRequest(`/v1/firm/activity?${params.toString()}`, {}, (json) => activityResponseSchema.parse(json));
}


/** GET /v1/firm/activity/summary (`view_activity`): Home's "This month" strip (D73). */
export function fetchActivitySummary(query: ActivitySummaryQuery): Promise<ActivitySummary> {
  const params = new URLSearchParams({ from: query.from });
  if (query.to) params.set("to", query.to);
  return apiRequest(`/v1/firm/activity/summary?${params.toString()}`, {}, (json) => activitySummarySchema.parse(json));
}
